@if (isLoading()) {
  <nk-spinner display="inline-block"></nk-spinner>
}
@if (roles$ | async; as roles) {
  <h6 class="mb-0 font-weight-bold">
    {{ 'screening.screening_overrides.suggestions.person_company_roles.title' | translate }}
    <nk-help-popover [popoverTemplate]="tipPopoverTemplate"></nk-help-popover>
  </h6>

  @if (roles.count > 0) {
    <table class="table table-striped table-dense small w-100">
      <thead>
        <tr class="sm text-muted">
          @if (showCompanyColumn()) {
            <th>
              {{ 'screening.screening_overrides.suggestions.person_company_roles.company' | translate }}
            </th>
          }
          <th>
            {{ 'screening.screening_overrides.suggestions.person_company_roles.role_title' | translate }}
          </th>
          <th>
            {{ 'screening.screening_overrides.suggestions.person_company_roles.from_date' | translate }}
          </th>
          <th>
            {{ 'screening.screening_overrides.suggestions.person_company_roles.to_date' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        @for (item of roles.elements; track item.company_role.uuid) {
          <tr>
            @if (showCompanyColumn()) {
              <td [class.font-weight-bold]="item.isConnected">
                <nk-company-title [company]="item.company" [showFlag]="false" [showOrgNr]="false"></nk-company-title>
              </td>
            }
            <td>{{ 'company_role.' + item.company_role.company_role_key | translate }}</td>
            <td>{{ item.person_company_role.from_date | date: dateFormats.Standard }}</td>
            <td>
              {{
                item.person_company_role.to_date
                  ? (item.person_company_role.to_date | date: dateFormats.Standard)
                  : ('screening.screening_overrides.suggestions.person_company_roles.still_active' | translate)
              }}
            </td>
          </tr>
        }
        @if (roles.elements.length > roles.count) {
          <tr>
            @if (showCompanyColumn()) {
              <td></td>
            }
            <td>
              @let personMasterUuid = inputData()?.person_master_uuid;
              @if (personMasterUuid) {
                <a class="text-capitalize" [routerLink]="'/person/' + personMasterUuid">
                  {{ 'screening.screening_overrides.suggestions.person_company_roles.see_more' | translate }}
                </a>
              }
            </td>
            <td></td>
            <td></td>
          </tr>
        }
      </tbody>
    </table>
    <hr />
  } @else {
    @if (!isLoading() && roles.count === 0) {
      <span class="text-muted small">{{
        'screening.screening_overrides.suggestions.person_company_roles.no_roles_found' | translate
      }}</span>
      <hr />
    }
  }
}

<ng-template #tipPopoverTemplate>
  <p class="mb-0">
    {{ 'screening.screening_overrides.suggestions.person_company_roles.help_text' | translate }}
  </p>
  <p class="mb-0 mt-2">
    <strong>{{ 'screening.screening_overrides.suggestions.person_company_roles.help_bold_text' | translate }}</strong>
    {{ 'screening.screening_overrides.suggestions.person_company_roles.help_bold_description' | translate }}
  </p>
</ng-template>
